var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.216.398.3.301c.371-.37.954-.399 1.358-.085L1.756.3 9 7.545 16.244.3c.37-.37.954-.399 1.358-.085l.097.085c.37.371.399.954.085 1.358l-.085.097L10.455 9l7.244 7.244c.37.37.399.954.085 1.358l-.085.097c-.371.37-.954.399-1.358.085l-.097-.085L9 10.455 1.756 17.7c-.37.37-.954.399-1.358.085L.301 17.7c-.37-.371-.399-.954-.085-1.358l.085-.097L7.545 9 .3 1.756C-.069 1.386-.098.802.216.398L.3.301z"
})));
export default SvgInstagramMobileClose;